import classNames from "classnames";
import CiroContactPill from "./CiroContactPill";
import { AutopilotContactLimitDetails } from "../../__generated__/graphql";

interface IMonthlyContactsRemainingProps {
  autopilotContactLimitDetails: AutopilotContactLimitDetails | null;
  customClassName?: string;
}

const MonthlyContactsRemaining = ({
  autopilotContactLimitDetails,
  customClassName,
}: IMonthlyContactsRemainingProps) => {
  if (!autopilotContactLimitDetails) {
    return null;
  }

  return (
    <div
      className={classNames(
        "flex",
        "items-center",
        "justify-between",
        customClassName,
      )}
    >
      <span className={classNames("text-sm", "font-medium", "text-gray-700")}>
        Monthly contacts remaining
      </span>
      <CiroContactPill
        amount={autopilotContactLimitDetails.remainingMonthlyContacts}
        showContactExplanationTooltip
      />
    </div>
  );
};

export default MonthlyContactsRemaining;
